// The verbatim view's placeholder height; the family's charts use the shared chart default.

export const VERBATIM_PLACEHOLDER_HEIGHT = 200
